import React, { useEffect, useRef, useState } from "react";
import { isEnterKey, isEscKey } from "@smartsuite/react-ui/lib/helpers/keys";
import { Button } from "@smartsuite/react-ui/lib/components/buttons/Button/Button";
import { whiteButtonStyles } from "@smartsuite/react-ui/lib/components/buttons/Button/Button.constant";
import { InputField } from "@smartsuite/react-ui/lib/components/forms/InputField/InputField";
import { EditorToolbar } from "../../../react/EditorToolbar/EditorToolbar";
import { text } from "../texts";
import { normalizeLink } from "../utils";
export const EditorUrlDialog = ({ href, onHrefChange, }) => {
    const inputRef = useRef();
    const [isEditing, setEditing] = useState(!href);
    useEffect(() => {
        if (isEditing) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [isEditing]);
    const handleEdit = () => {
        setEditing(true);
    };
    const handleSave = () => {
        const updatedHref = inputRef.current.value;
        onHrefChange(updatedHref);
    };
    const handleRemove = () => {
        onHrefChange(null);
    };
    const handleKeyDown = (event) => {
        if (isEnterKey(event.nativeEvent)) {
            handleSave();
            event.stopPropagation();
            event.preventDefault();
        }
        if (isEscKey(event.nativeEvent)) {
            onHrefChange(href);
            event.stopPropagation();
            event.preventDefault();
        }
    };
    return (React.createElement(EditorToolbar, { className: "editor-url-dialog" },
        !isEditing && (React.createElement(React.Fragment, null,
            React.createElement("a", { className: "editor-url-dialog__link", href: normalizeLink(href), target: "_blank", rel: "noreferrer" }, href),
            React.createElement(Button, { styles: whiteButtonStyles, className: "editor-url-dialog__button", onClick: handleEdit }, text.edit))),
        isEditing && (React.createElement(React.Fragment, null,
            React.createElement(InputField, { ref: inputRef, placeholder: text.placeholder, value: href, maxLength: 1000, onKeyDown: handleKeyDown }),
            React.createElement(Button, { styles: whiteButtonStyles, className: "editor-url-dialog__button", onClick: handleSave }, href ? text.save : text.add))),
        href && (React.createElement(Button, { styles: whiteButtonStyles, className: "editor-url-dialog__button", onClick: handleRemove }, text.remove))));
};
